// 0.65 (Texto 3 C): nada das abas entra sozinho no My Planner, com três exceções: remédios, consultas e a carta do Diário.
// Consulta com data: ao salvar, vira uma tarefa ligada à ficha (ou atualiza a que já existe).
import { getDoc } from '../store/store';
import { newTask, saveTask } from '../store/planner';
import { mudarReg } from '../store/modulos';
import type { ModId, Reg, Task } from '../store/types';
import { estaAguardando, paraPlanner } from '../lib/envioEstado';

export function consultaNoPlanner(mod: ModId, r: Reg, p: Partial<Task> & { start?: string }) {
  if (!p.start) return;
  const ja = r.tarefa ? getDoc('planner').tasks.find(x => x.id === r.tarefa) : null;
  // texto 10 (E3): consulta "Aguardando confirmação" não vai sozinha (só se a pessoa enviar de propósito)
  if (!ja && estaAguardando(mod, r.id)) return;
  // texto 10 (E4): no My Planner só o título, o horário e o nome do médico ou profissional
  const dados: Partial<Task> = paraPlanner(mod, r.id, { title: p.title ?? '', start: p.start, time: p.time ?? null, notes: p.notes ?? '', area: mod, emoji: '🩺', emojiManual: true,
    link: { aba: mod, id: r.id, label: p.title ?? '' }, duration: 50, alerts: { mode: 'start', before: [60] } }, mod === 'saude' ? String(r.c.medico ?? '') : '');
  if (ja) { saveTask({ ...ja, ...dados, updatedAt: new Date().toISOString() }); return; }
  const tk = newTask(dados);
  saveTask(tk);
  mudarReg(mod, r.id, x => ({ ...x, tarefa: tk.id }));
}
